import { Directive, HostListener } from '@angular/core';
import { NgControl, FormGroup } from '@angular/forms'
@Directive({
  selector: '[appEvaluaRequeridos]'
})
export class EvaluaRequeridosDirective {

  constructor(public control:NgControl) { }

  @HostListener('input', ['$event']) changeForm() {
     if(this.control.control.value == ''){      
      this.control.control.setErrors({'esRequerido': true})
     } 
  }
}
